import type { ParsedTransactionCandidate } from "./types";

export async function getOpenRouterProxyStatus() {
  const response = await fetch("/api/openrouter/status", {
    method: "GET",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) return { configured: false };
  return (await response.json()) as { configured: boolean };
}

export async function parseTextWithOpenRouter(text: string): Promise<ParsedTransactionCandidate | null> {
  if (!text.trim()) return null;

  const response = await fetch("/api/openrouter/text", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text }),
  });

  if (!response.ok) return null;
  const payload = (await response.json()) as { candidate?: ParsedTransactionCandidate };
  return payload.candidate ?? null;
}

export async function parseReceiptWithOpenRouter(dataUrl: string): Promise<ParsedTransactionCandidate | null> {
  if (!dataUrl.trim()) return null;

  const response = await fetch("/api/openrouter/receipt", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ dataUrl }),
  });

  if (!response.ok) return null;
  const payload = (await response.json()) as { candidate?: ParsedTransactionCandidate };
  return payload.candidate ?? null;
}
